import { useLang } from '@/i18n';
import EfIcon from '@elem/ui/ef-icon';
import EfImg from '@elem/ui/ef-img';
import EfProductCompareC from '@elem/ui/ef-product-compare-c';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import { useMemo } from 'react';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';

export default function TheComp() {
    const { locale = 'jp' } = getLocal();
    const { t } = useLang('theProduct.SectionB');

    const listA = {
        title: t('a_title'),
        specList: [
            {
                title: t('a_item1_t'),
                desc: t('a_item1_b'),
            },
            {
                title: t('a_item2_t'),
                desc: t('a_item2_b'),
            },
            {
                title: t('a_item3_t'),
                desc: t('a_item3_b'),
            },
            {
                title: t('a_item4_t'),
                desc: t('a_item4_b'),
            },
        ],
    };

    const listB = {
        title: t('b_title'),
        specList: [
            {
                title: t('b_item1_t'),
                desc: t('b_item1_b'),
            },
            {
                title: t('b_item2_t'),
                desc: t('b_item2_b'),
            },
            {
                title: t('b_item3_t'),
                desc: t('b_item3_b'),
            },
            {
                title: t('b_item4_t'),
                desc: t('b_item4_b'),
            },
        ],
    };

    const listAll = [listA, listB];

    const img = useMemo(() => {
        switch (locale) {
            case 'cn':
                return {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1737612565993/SectionB-pc.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1737612565993/SectionB-pc.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1737612587305/SectionB-h5.jpg',
                };
            case 'jp':
            default:
                return {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1724569866722/sectionB.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1724569866722/sectionB.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1724402765597/a12-h5.jpg',
                };
        }
    }, [locale]);
    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfIcon className="SectionB-top-icon" pc="https://websiteoss.ecoflow.com/upload/image/1724210988687/x-core.png" />
            <EfSection hasAnimation={false} title={t('title')} desc={t('desc')} />
            <div className="ef-container SectionB-in">
                <div className="SectionB-l">
                    <EfImg pc={img.pc} pad={img.pad} h5={img.h5} />
                </div>
                <div className="SectionB-r">
                    <div className="SectionB-r-in">
                        <EfProductCompareC items={listAll} theme="transparent" />
                    </div>
                </div>
            </div>
        </div>
    );
}
